<template>
	<div class="container">
		<div class="main_box">
			<!--联系我们-->
			<fixed></fixed>
			<!--联系我们-->
			<!--导航-->
			<navbar></navbar>
			<!--导航-->
			<!--块1-->
			<div class="block_1">
				<div class="title"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>You are applying for: <span>{{ pageTitle }}</span></div>
				<div class="text"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>Fill the form below accurately indicating your potential suitability to job applying for.</div>
				<div class="form_box"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="form_box_el">
						<div class="form_el form_left">
							<div class="label">First name<span>*</span></div>
							<div class="input_el">
								<input v-model="firstVal" :class="isClick && !firstVal ? 'err' : ''" />
							</div>
							<div v-show="isClick && !firstVal" class="error">Please complete this required field.</div>
						</div>
						<div style="width: 4%;"></div>
						<div class="form_el form_right">
							<div class="label">Last name<span>*</span></div>
							<div class="input_el">
								<input v-model="lastVal" :class="isClick && !lastVal ? 'err' : ''" />
							</div>
							<div v-show="isClick && !lastVal" class="error">Please complete this required field.</div>
						</div>
					</div>
					<div class="form_box_el">
						<div class="form_el form_left">
							<div class="label">Email<span>*</span></div>
							<div class="input_el">
								<input v-model="emailVal" :class="isClick && !emailVal ? 'err' : ''" />
							</div>
							<div v-show="isClick && !emailVal" class="error">Please complete this required field.</div>
						</div>
						<div style="width: 4%;"></div>
						<div class="form_el form_right">
							<div class="label">Phone<span>*</span></div>
							<div class="input_el">
								<input v-model="phoneVal" :class="isClick && !phoneVal ? 'err' : ''" />
							</div>
							<div v-show="isClick && !phoneVal" class="error">Please complete this required field.</div>
						</div>
					</div>
					<div class="form_box_el">
						<div class="form_el form_left">
							<div class="label">State<span>*</span></div>
							<div class="input_el">
								<input v-model="stateVal" :class="isClick && !stateVal ? 'err' : ''" />
							</div>
							<div v-show="isClick && !stateVal" class="error">Please complete this required field.</div>
						</div>
						<div style="width: 4%;"></div>
						<div class="form_el form_right">
							<div class="label">Postal code<span>*</span></div>
							<div class="input_el">
								<input v-model="postalCodeVal" :class="isClick && !postalCodeVal ? 'err' : ''" />
							</div>
							<div v-show="isClick && !postalCodeVal" class="error">Please complete this required field.</div>
						</div>
						<div style="width: 4%;"></div>
						<div class="form_el form_right">
							<div class="label">City<span>*</span></div>
							<div class="input_el">
								<input v-model="cityVal" :class="isClick && !cityVal ? 'err' : ''" />
							</div>
							<div v-show="isClick && !cityVal" class="error">Please complete this required field.</div>
						</div>
					</div>
					<div class="form_el">
						<div class="label_tit">
							If hired, would you be able to present evidence of your U.S. citizenship or proof of your legal right to work in the United States? (Note: While lack of U.S. citizenship does not disqualify you for all positions, it may for those that require extensive U.S. travel.)
						</div>
						<div class="radio_el">
							<el-radio v-model="radio1" label="1">Yes</el-radio>
						</div>
						<div class="radio_el">
							<el-radio v-model="radio1" label="2">No</el-radio>
						</div>
					</div>
					<div class="form_el">
						<div class="label">Desired start date<span>*</span></div>
						<div :class="isClick && !timeVal ? 'date_err' : ''">
							<el-date-picker
								v-model="timeVal"
								type="date"
								placeholder=""
							>
							</el-date-picker>
						</div>
						<div v-show="isClick && !timeVal" class="error">Please complete this required field.</div>
					</div>
					<div class="form_el">
						<div class="label">Upload Resume<span>*</span></div>
						<div class="unload_box">
							<el-upload
								class="upload-demo"
								action="/apis/api/index/uploads"
								name="files"
								:show-file-list="false"
								:on-success="handleAvatarSuccess"
								:multiple="false"
								:limit="1"
								:file-list="fileList"
							>
								<div class="tit">Upload files</div>
							</el-upload>
						</div>
						<div class="uploaded_box">{{ files }} <span v-if="filesUrl" @click="delFiles">删除</span></div>
						<div v-show="isClick && !filesUrl" class="error">Please complete this required field.</div>
					</div>
					<div class="form_el">
						<div class="label">Cover letter<span>*</span></div>
						<div class="input_el">
							<textarea v-model="coverLetterVal" :class="isClick && !coverLetterVal ? 'err' : ''" style="height: 80px;line-height: 20px;"></textarea>
						</div>
						<div v-show="isClick && !coverLetterVal" class="error">Please complete this required field.</div>
					</div>
					<div class="form_el">
						<div class="label_tit">
							Are you able to provide three (3) relevant references for your work? (Note: We will not ask for references at this stage in the hiring process).
						</div>
						<div class="radio_el">
							<el-radio v-model="radio2" label="1">Yes</el-radio>
						</div>
						<div class="radio_el">
							<el-radio v-model="radio2" label="2">No</el-radio>
						</div>
					</div>
					<div class="form_el">
						<div class="label">Where did you hear about this position?<span>*</span></div>
						<div class="input_el">
							<input v-model="positionVal" :class="isClick && !positionVal ? 'err' : ''" />
						</div>
						<div v-show="isClick && !positionVal" class="error">Please complete this required field.</div>
					</div>
					<div class="form_el">
						<div class="label_tit">
							Acceptance<span style="color: #f2545b;">*</span><br />
							<el-checkbox v-model="checkbox"></el-checkbox> I certify that the information contained in this application is true and complete. I understand that false information may be grounds for not hiring me or for immediate termination of employment if I am hired. I authorize the verification of any and all information listed above.
						</div>
						<div v-show="isClick && !checkbox" class="error">Please complete this required field.</div>
					</div>
					<div v-show="isClick && !firstVal && !lastVal && !emailVal && !phoneVal && !stateVal && !postalCodeVal && !cityVal && !coverLetterVal && !positionVal && !timeVal && !files && !checkbox" class="tips_box">
						<div class="error">Please complete all required fields.</div>
					</div>
					<div class="btn_box_more btn_box" @click="subClick">
						Apply<img src="../../assets/img/组 32@2x.png" />
					</div>
				</div>
			</div>
			<!--块1-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<van-popup v-model="sussessShow" :style="{ width: '900px' }" closeable @close="closePop" :close-on-click-overlay="false">
			<div class="sussess_box">
				<div class="img_box">
					<img src="../../assets/img/组 316@2x.png" />
				</div>
				<div class="tit">Thank You</div>
				<div class="txt">
					Your application was sent succesfully. Someone from our<br /> team will get in touch.
				</div>
			</div>
		</van-popup>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navbar from '@/component/pc/nav.vue'  //导航组件
import footerBox from '@/component/pc/footer.vue'  //版权组件
import fixed from '@/component/pc/fixed.vue'  //联系我们悬浮
import { careersFormSubmit, uploadFiles } from '@/api/public';
import moment from 'moment';
export default {
	components:{
		navbar,
		footerBox,
		fixed,
	},
	data() {
		return {
			isLoading: true,  //界面loading
			firstVal: '',
			lastVal: '',
			emailVal: '',
			phoneVal: '',
			stateVal: '',
			postalCodeVal: '',
			cityVal: '',
			coverLetterVal: '',
			positionVal: '',
			radio1: '',
			radio2: '',
			timeVal: '',
			files: '',
			filesUrl: '',
			fileList: [],
			checkbox: false,
			isClick: false,
			pageTitle: '',
			sussessShow: false,
		}
	},
	created(){
		let that = this;
		window.scroll(0, 0);
		if(sessionStorage.getItem('careersName')) {
			that.pageTitle = sessionStorage.getItem('careersName');
			document.title = sessionStorage.getItem('careersName') + ' - CorDx';
			that.isLoading = false;
		}
	},
	mounted() {
		let that = this;
	},
	watch: {
		//
	},
	methods: {
		//删除附件
		delFiles() {
			this.files = '';
			this.filesUrl = '';
			this.fileList = [];
		},
		//上传附件
		handleAvatarSuccess(res, file) {
			this.filesUrl = res.data.thumb;
			this.files = file.name;
		},
		//提交
		subClick() {
			let that = this;
			that.isClick = true;
			if(that.checkbox && that.emailVal && that.firstVal && that.lastVal && that.phoneVal && that.stateVal && that.postalCodeVal && that.cityVal && that.timeVal && that.coverLetterVal && that.positionVal && that.filesUrl) {
				that.$toast.loading({
					forbidClick: true,
				});
				careersFormSubmit({
					first_name: that.firstVal,
					last_name: that.lastVal,
					email: that.emailVal,
					phone_number: that.phoneVal,
					state: that.stateVal,
					postal_code: that.postalCodeVal,
					city: that.cityVal,
					is_zhengming: that.radio1,
					start_date: moment(that.timeVal).valueOf(),
					resume: that.filesUrl,
					cover_letter: that.coverLetterVal,
					is_word: that.radio2,
					source: that.positionVal,
					careers: that.pageTitle,
				}).then(res => {
					that.$toast.clear();
					that.firstVal = '';
					that.lastVal = '';
					that.emailVal = '';
					that.phoneVal = '';
					that.stateVal = '';
					that.postalCodeVal = '';
					that.cityVal = '';
					that.coverLetterVal = '';
					that.positionVal = '';
					that.radio1 = '';
					that.radio2 = '';
					that.timeVal = '';
					that.files = '';
					that.filesUrl = '';
					that.fileList = [];
					that.checkbox = false;
					that.isClick = false;
					that.sussessShow = true;
				});
			}
		},
		closePop() {},
	}
}
</script>

<style lang="less" scoped>
/*弹框*/
.sussess_box{
	width: 100%;
	padding: 50px 0 80px 0;
	text-align: center;
	background-image: linear-gradient(180deg,  #F9FAFE 100%, #FFFFFF 20%);
	.txt{
		font-size: 24px;
	}
	.tit{
		padding: 20px 0 20px 0;
		font-size: 45px;
	}
	.img_box{
		img{ width: 350px; }
	}
}
.main_box{
	width: 100%;
	height: auto;
	/*块1*/
	.block_1{
		width: 800px;
		margin: 0 auto;
		padding: 80px 0 100px 0;
		.unload_box{
			.tit{
				padding: 8px 0;
				color: #0B318F;
			}
		}
		.uploaded_box{
			padding: 0px 0;
			font-size: 18px;
			color: #000000;
			span{
				display: inline-block;
				margin-left: 10px;
				font-size: 14px;
				color: #0B318F;
				cursor: pointer;
			}
		}
		.label_tit{
			padding: 10px 0;
			font-size: 18px;
		}
		.form_box{
			margin-top: 50px;
			padding: 20px 40px 50px 40px;
			background-color: #F9FAFE;
			.btn_box{
				margin: 40px 0 0 40%;
			}
			.tips_box{
				margin-top: 20px;
				.error{
					font-size: 13px;
					font-family: helvetica;
					color: #f2545b;
				}
			}
			.form_box_el{
				display: flex;
				.form_left{
					flex: 1;
				}
				.form_right{
					flex: 1;
				}
			}
			.form_el{
				width: 100%;
				margin-top: 15px;
				.input_el{
					input, textarea, select{
						width: 100%;
						height: 40px;
						line-height: 40px;
						padding: 9px 10px;
						background-color: #ffffff;
						color: #33475b;
						border: 1px solid #cbd6e2;
					}
					input.err, textarea.err, select.err{
						border: 1px solid #c87872;
					}
				}
				.label{
					font-size: 13px;
					font-family: helvetica;
					color: #0B318F;
					span{
						color: #f2545b;
					}
				}
				.error{
					font-size: 13px;
					font-family: helvetica;
					color: #f2545b;
				}
			}
		}
		.text{
			padding-top: 10px;
			font-size: 18px;
		}
		.title{
			font-size: 35px;
			span{
				margin-left: 20px;
				font-size: 35px;
				font-weight: bold;
			}
		}
	}
	.btn_box_more{
		display: inline-block;
		padding: 0 28px;
		height: 42px;
		line-height: 42px;
		font-size: 20px;
		color: #0B318F;
		background: #FFFFFF;
		border-radius: 22px 22px 22px 22px;
		border: 1px solid #0B318F;
		text-align: center;
		cursor: pointer;
		img{
			width: 20px;
			position: relative;
			top: 10px;
			left: 10px;
			transition: all 0.3s;
		}
	}
	.btn_box_more:hover{
		img{
			transform: translateX(6px);
		}
		background-color: #f5f8fa;
	}
}
</style>
<style scoped>
>>> .form_box .el-radio__input.is-checked .el-radio__inner, >>> .form_box .el-checkbox__input.is-checked .el-checkbox__inner{
	background: #0B318F;
	border-color: #0B318F;
}
>>> .form_box .el-checkbox__inner:hover{
	border-color: #0B318F !important;
}
>>> .form_box .el-radio__input.is-checked+.el-radio__label{
	color: #0B318F;
}
>>> .date_err .el-input--suffix .el-input__inner{
	border: 1px solid #c87872;
}
/* >>> .form_box .el-date-table td.current:not(.disabled) span{
	background-color: #0B318F !important;
}
>>> .form_box .el-date-table td.today span{
	color: #0B318F !important;
} */
</style>
